import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@chakra-ui/react'

import { Title } from '../../../Components/Atoms'
import { Stack } from '../../../Components/Organisms/Graphs'

import { ArrowRightIcon, AddModelIcon, VehiclesLeasedPlaceholder } from '../../../Assets/images/svgs'
import { MODEL_COLORS } from '../../../Assets/styles/colors'

import PATHS from "../../../Routes/paths";
import { getVehicleLeasedStats } from '../../../APIs'

import "./style.css"

const VehiclesLeased = ({client}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [leaseCount, setLeaseCount] = useState(0);
  const [chartData, setChartData] = useState(null);
  const [chartLabelData, setChartLabelData] = useState(null)

  const navigate = useNavigate();

  const getChartData = useCallback(async () => {
    const resp = await getVehicleLeasedStats(client.idx);

    if(!resp || !resp.length) {
      global.EE.emitEvent(global.EE.EVENT_TYPES.LEASED_VEHICLES_FETCHED, { clientId: -1 })
      setChartData(null);
      setIsLoading(false);
      return;
    };

    let labels = [];
    const parsedData = [];
    let countArr = new Array(resp.length);
    setLeaseCount(0);

    resp.forEach((veh, i) => {
      countArr.fill(0)
      countArr[i] = veh.count;

      let data = {
        model: veh.mo,
        modelId: veh._id,
        count: [...countArr],
        color: MODEL_COLORS[i % MODEL_COLORS.length]
      }

      parsedData.push(data);
      labels.push(veh.mo);
      setLeaseCount((old) => (old + veh.count));
    });

    setChartLabelData(labels);
    setChartData(parsedData);
    setIsLoading(false);

    global.EE.emitEvent(global.EE.EVENT_TYPES.LEASED_VEHICLES_FETCHED, { clientId: client.idx });

  }, [client.idx]);

  useEffect(() => {
    getChartData();
  }, [client.idx, getChartData])

  const parser = {
    x: "model",
    y: "count",
    xLabel: "No. of vehicles",
    yLabel: "Vehicles Model",
  };

  if (isLoading) return null;
  return (
    <article className="widget-main veh-leased-stats">
      {chartData ? (
        <>
          <header className="widget-header veh-leased-stats-header">
            <Title variant="md" fixed>Vehicles</Title>
            <Title variant="md" fixed>{leaseCount} Vehicles leased</Title>
            <span></span>
          </header>

          <div className="panel-chart-main veh-leased-stats-chart">
            <Stack data={chartData} labels={chartLabelData} parser={parser} title="Vehicles Leased" options={{ indexAxis: "y" }} />
          </div>

          <div className="widget-link veh-leased-stats-btn">
            <Button variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => navigate(PATHS.LEASED_VEHICLES)}>
              View Reports
            </Button>
          </div>
        </>
      ) : <NoVehiclesLeased client={client} navigate={navigate}/>}
    </article>
  )
}

const NoVehiclesLeased = ({client, navigate}) => {
  return (
    <div className='no-vehicle-leased'>
      <VehiclesLeasedPlaceholder />
      <h1 className='no-vehicle-lease-page-text'>No Vehicles leased yet</h1>
      <Button leftIcon={<AddModelIcon />} className="panel-button add-new-modal-btn" onClick={() => navigate(PATHS.LEASE_VEHICLES)}>Lease vehicle to {client.cName}</Button>
    </div>
  )
}

export default VehiclesLeased
